import { useEffect } from "react";
import { Stack } from "@mui/material";
import { NavigationItem } from "utils/helpers/NavigationItem";
import { iconArrowCircleRight } from "theme/icons";
import { TreeNode } from "types/cds";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
  theoryState,
  theoryAreaState,
  theoryChapterState,
  theoryStateSelected,
  theoryStateAreas,
} from "state/theoryState";
import { useNavigate } from "react-router-dom";
import { learningStructureState } from "state/learningStructureState";
import { testId } from "tests/testIdStrings";
import { activityProgressState } from "state/progresState";
import { ItemTitleValuePair } from "services/reportingService";

export const TheoryAreas = () => {
  // Hämtar elevens utbildningsstruktur från CDS
  const structure = useRecoilValue(learningStructureState);

  // Setter för att spara ner theoryState
  const setTheoryState = useSetRecoilState(theoryState);
  const setChapterState = useSetRecoilState(theoryChapterState);

  // Hämtar ut alla noder på första nivån från theoryState
  const areas = useRecoilValue(theoryStateAreas);

  const progress = useRecoilValue(activityProgressState);

  // Sätter hela strukturen i theoryState
  useEffect(() => {
    if (structure) setTheoryState(structure);
  }, [structure, setTheoryState, setChapterState]);

  if (!structure) return null;
  if (!structure.length) throw new Error("The education has no content");

  return (
    <Stack spacing={3}>
      {areas.map((item: TreeNode, index: number) => (
        <AreaItem key={item.id} item={item} index={index} progress={progress} />
      ))}
    </Stack>
  );
};

const AreaItem = ({ item, index, progress }: { item: TreeNode; index: number; progress?: ItemTitleValuePair[] }) => {
  const navigate = useNavigate();

  // Setter för att spara ner theoryState
  const setAreaState = useSetRecoilState(theoryAreaState);

  // Läser/Sätter vald nod på theoryStateSelected
  const setTheorySelected = useSetRecoilState(theoryStateSelected);

  const handleSelectedItem = (item: TreeNode) => {
    let path = item.id.toString();
    setTheorySelected(item);
    setAreaState(item);

    navigate(path);
  };

  // Hämtar progress för aktivity
  const areaProgress = parseInt(progress?.find((p) => p.title === item.activityKey?.versionId)?.value || "0");

  return (
    <NavigationItem
      size="large"
      key={item.id}
      text={item.title}
      icon={item.icon}
      navigationIcon={iconArrowCircleRight}
      onClick={() => handleSelectedItem(item)}
      progressValue={areaProgress}
      dataTestIdString={`${testId.listItem.theory.areas}-${index + 1}`}
    />
  );
};
